import axios from '../configs/axios';
import { serializeQuery } from '../utility/helpers/serializeQuery';

class LrsUserRepository {
    async create(payload) {
        const response = await axios.post('lrsUser', payload);
        return response;
    }

    async getById(id) {
        const response = await axios.get(`lrsUser/${id}`);
        return response;
    }

    async update(userId, payload) {
        const response = await axios.put(`lrsUser/${userId}`, payload);
        return response;
    }

    async getLrsUsers(payload) {
        const response = await axios.get(`lrsUser?${serializeQuery(payload)}`);
        return response;
    }

    async deleteLrsUser(userId) {
        const response = await axios.delete(`lrsUser/${userId}`);
        return response;
    }

    async searchLrsUsersByPhoneOrEmail(payload) {
        const response = await axios.get(
            `lrsUser/search?${serializeQuery(payload)}`,
        );
        return response;
    }

    async getLrsUsersByLawyer(lawyerId, payload) {
        const response = await axios.get(
            `lrsUser/by_lawyer/${lawyerId}?${serializeQuery(payload)}`,
        );

        return response;
    }

    async getLrsUsersByUser(userId, payload) {
        const response = await axios.get(
            `lrsUser/by_user/${userId}?${serializeQuery(payload)}`,
        );

        return response;
    }

    async getLrsUserAndReferralsByLawyer(lawyerId, lrsUserId, payload) {
        const response = await axios.get(
            `lrsUser/by_lawyer/${lawyerId}/${lrsUserId}?${serializeQuery(
                payload,
            )}`,
        );

        return response;
    }
}

export default new LrsUserRepository();
